import { j as g } from "../../jsx-runtime-B6kdoens.js";
import { c as h } from "../../index-CROKJrb5.js";
import { c as b, f } from "../../create-component-CBAeEoQ6.js";
const t = {
  thin: "cur-font-thin",
  light: "cur-font-light",
  normal: "cur-font-normal",
  md: "cur-font-md",
  bold: "cur-font-bold",
  extrabold: "cur-font-extrabold",
  black: "cur-font-black"
}, m = h({
  variants: {
    weight: {
      100: t.thin,
      300: t.light,
      400: t.normal,
      500: t.md,
      700: t.bold,
      800: t.extrabold,
      900: t.black,
      thin: t.thin,
      light: t.light,
      normal: t.normal,
      md: t.md,
      bold: t.bold,
      extrabold: t.extrabold,
      black: t.black
    },
    // Size comes after weight because some sizes override the weight
    size: {
      inherit: "cur-text-inherit cur-font-body",
      d1: "cur-text-d1m lg:cur-text-d1 cur-tracking-d1m lg:cur-tracking-d1 cur-leading-d1m lg:cur-leading-d1 lg:cur-font-display cur-font-heading cur-font-bold",
      d2: "cur-text-d2m lg:cur-text-d2 cur-tracking-d2m lg:cur-tracking-d2 cur-leading-d2m lg:cur-leading-d2 cur-font-bold cur-font-heading",
      h1: "cur-text-h1 cur-tracking-h1 cur-leading-h1 cur-font-bold cur-font-heading",
      h2: "cur-text-h2 cur-tracking-h2 cur-leading-h2 cur-font-bold cur-font-heading",
      h3: "cur-text-h3 cur-tracking-h3 cur-leading-h3 cur-font-bold cur-font-heading",
      subhead: "cur-text-subhead cur-tracking-subhead cur-leading-subhead cur-font-body",
      body: "cur-text-body cur-tracking-body cur-leading-body cur-font-body",
      "body-lg": "cur-text-body-lg cur-tracking-body-lg cur-leading-body-lg cur-font-body",
      meta: "cur-text-meta cur-tracking-meta cur-leading-meta cur-font-body",
      cta: "cur-text-cta cur-tracking-cta cur-leading-cta cur-font-body"
    },
    italic: {
      true: "cur-italic"
    },
    underlined: {
      true: "cur-underline"
    }
  },
  compoundVariants: [
    {
      weight: ["normal", "400"],
      size: ["cta"],
      className: "cur-font-bold"
    },
    {
      weight: ["normal", "400"],
      size: ["subhead"],
      className: "cur-font-medium"
    }
  ]
}), s = ["d1", "d2", "h1"], y = (r) => s.includes(r) ? "h1" : r === "h2" ? "h2" : r === "h3" ? "h3" : r === "cta" ? "a" : "div", w = b(
  "Typography",
  f(
    ({
      children: r,
      as: a,
      size: n = "inherit",
      italic: o = !1,
      weight: e = "normal",
      className: u,
      ...d
    }, l) => {
      const c = a || y(n), i = m({
        className: u,
        size: n,
        weight: e,
        italic: o,
        underlined: c === "a" || typeof c == "function"
      });
      return /* @__PURE__ */ g.jsx(c, { ref: l, className: i, ...d, children: r });
    }
  )
);
export {
  w as Typography
};
//# sourceMappingURL=index.js.map
